import React from "react"
import styles from "./listing.module.scss"

const SNGlisting = ({ events = [] }) => {



    return (
        <section className={styles.snglisting} id="events">
            <div className={styles.containfix}>
                <h1 className={styles.eventsheader}>2021<br /> <span className={styles.pinkify}>WEBINARS</span></h1>
                <div className={styles.outerColGrid}>
                    <div className={styles.divCol1}>
                        {events.map((event, index) => 
                            <a key={index} className={styles.listButtonNew} href={`${process.env.GATSBY_PATH_PREFIX}/${event.slug}`}>
                                <div className={styles.eShell}>
                                    <div className={styles.leftie}>
                                        <div className={styles.eTitle}>{event.title}</div>
                                        <div className={styles.eDate}>{event.date}</div>
                                    </div>
                                    <div className={styles.eLearn}>{event.linktext} <i className="fa fa-caret-right"></i></div>
                                    <div className={styles.clearme}></div>
                                </div>
                            </a>
                        )}
                    </div>

                </div>



            </div>
        </section>
    )
}

export default SNGlisting